/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <ModalExito v-show="mostrarExito" :mostrarExito="mostrarExito" />
  <LoadScreen v-if="mostrarLoaderDos" />
  <LayoutPrincipal>
    <ContainerWhite>
      <div style="height: 100%; display: flex; flex-direction: column;">
        <section class="filtrosEmpleados">
          <div class="tituloModulo">Módulo Instaladores</div>
          <div>
            <input class="inputBuscador" type="text" v-model="searchText" placeholder="Buscar por nombre" />
          </div>
        </section>

        <section class="tabla-con-loader" style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">
          <div class="tabla-scrollable" ref="tableContainer" style="flex: 1; overflow-y: auto;">
            <table class="default">
              <thead>
                <tr class="cabecera">
                  <th>ID</th>
                  <th>Nombre Completo</th>
                  <th class="desktop-only">Estado</th>
                  <th class="desktop-only">Ciudad</th>
                  <th class="desktop-only">Domicilio</th>
                  <th class="desktop-only">Correo</th>
                  <th class="desktop-only">Telefono</th>
                  <th class="desktop-only">Fecha de Registro</th>
                  <th class="mobile-only" style="width: 50px;">Ver</th>
                </tr>
              </thead>
              <tbody class="tbody">
                <tr v-if="mostrarLoader" class="fila-loader">
                  <td colspan="9" class="loader-wrapper">
                    <LoadScreenModal class="loader-solo" />
                  </td>
                </tr>
                <tr v-else-if="filteredList.length === 0">
                  <td colspan="9" class="mensajeNoResultados">No se encontraron resultados</td>
                </tr>
                <template v-else v-for="cliente in filteredList" :key="cliente.id_usuario">
                  <tr :class="{ 'fila-activa': isExpanded(cliente.id_usuario) }">
                    <td>
                      <span class="folio-text">{{ String(cliente.id_usuario).padStart(3, '0') }}</span>
                    </td>
                    <td class="nombre-celda">
                      {{ capitalizeWords(cliente.nombre) + ' ' + capitalizeWords(cliente.ape_pat) + ' ' +
                        capitalizeWords(cliente.ape_mat) }}
                    </td>
                    <td class="desktop-only">{{ cliente.estado }}</td>
                    <td class="desktop-only">{{ cliente.ciudad }}</td>
                    <td class="desktop-only">{{ cliente.domicilio }}</td>
                    <td class="desktop-only">{{ cliente.correo }}</td>
                    <td class="desktop-only">{{ cliente.telefono }}</td>
                    <td class="desktop-only">{{ formatarFecha(cliente.fecha_registro) }}</td>
                    <td class="mobile-only">
                      <Button class="btn-toggle" @click="toggleRow(cliente.id_usuario)">
                        <i
                          :class="isExpanded(cliente.id_usuario) ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
                      </Button>
                    </td>
                  </tr>
                  <tr v-if="isExpanded(cliente.id_usuario)" class="mobile-detail-row">
                    <td colspan="4" class="detail-cell">
                      <div class="detalle-wrapper">
                        <div class="info-grid">
                          <div class="info-item">
                            <span class="label">Estado</span>
                            <span class="value">{{ cliente.estado }}</span>
                          </div>
                          <div class="info-item">
                            <span class="label">Ciudad</span>
                            <span class="value">{{ cliente.ciudad }}</span>
                          </div>
                          <div class="info-item full-width">
                            <span class="label">Domicilio</span>
                            <span class="value">{{ cliente.domicilio }}</span>
                          </div>
                          <div class="info-item full-width">
                            <span class="label">Correo</span>
                            <span class="value">{{ cliente.correo }}</span>
                          </div>
                          <div class="info-item">
                            <span class="label">Teléfono</span>
                            <span class="value">{{ cliente.telefono }}</span>
                          </div>
                          <div class="info-item">
                            <span class="label">Registro</span>
                            <span class="value">{{ formatarFecha(cliente.fecha_registro) }}</span>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </ContainerWhite>
    <AgregarAdministrador v-if="mostrarModal" @cancelar="mostrarModal = false" />
    <Paginacion class="paginacion-fija" :paginaActualEntrada="currentPage" :total="totalPages"
      @changePagina="changePage" />
  </LayoutPrincipal>
</template>

<script setup>
import { ref, onMounted, computed, watch, onUnmounted } from 'vue';
import LayoutPrincipal from "../layouts/layoutPrincipal.vue";
import ContainerWhite from "../layouts/ContainerWhite.vue";
import Button from "../components/Forms/Button.vue";
import Paginacion from "../components/Forms/Paginacion.vue";
import AgregarAdministrador from "../components/Administrador/AgregarAdministrador.vue";
import ModalExito from '../components/Modales/ModalExito.vue';
import LoadScreenModal from "../components/Forms/LoadScreenModal.vue";
import LoadScreen from "../components/Forms/LoadScreen.vue";
import userService from '@/services/userService.js';

const mostrarLoader = ref(false);
const searchText = ref('');
const mostrarExito = ref(false);
const mostrarLoaderDos = ref(false);
const mostrarModal = ref(false);
const clientes = ref([]);
const expandedRows = ref([]);
const tableContainer = ref(null);

const itemsPerPage = ref(10);
const currentPage = ref(1);

const updateItemsPerPage = () => {
  if (tableContainer.value) {
    const containerHeight = tableContainer.value.clientHeight;
    const headerHeight = 50;
    const rowHeight = 56;
    const calculated = Math.floor((containerHeight - headerHeight) / rowHeight);
    itemsPerPage.value = calculated > 0 ? calculated : 5;
  }
};

const fetchInstaladores = async () => {
  mostrarLoader.value = true;
  const rolInstalador = 2;
  try {
    const response = await userService.getUsersByRol(rolInstalador);
    clientes.value = response.data;
    setTimeout(updateItemsPerPage, 100);
  } catch (err) {
    console.error("Error al cargar clientes:", err);
  } finally {
    mostrarLoader.value = false;
  }
};

onMounted(() => {
  fetchInstaladores();
  window.addEventListener('resize', updateItemsPerPage);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateItemsPerPage);
});

const capitalizeWords = (str) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const filteredAndSortedList = computed(() => {
  let listaFiltrada = clientes.value;
  if (searchText.value && listaFiltrada.length > 0) {
    const search = searchText.value.toLowerCase();
    listaFiltrada = listaFiltrada.filter(cliente => {
      const folioMatch = String(cliente.id_usuario).includes(search);
      const fullName = `${cliente.nombre} ${cliente.ape_pat} ${cliente.ape_mat}`.toLowerCase();
      const nameMatch = fullName.includes(search);
      const emailMatch = cliente.correo && cliente.correo.toLowerCase().includes(search);
      return folioMatch || nameMatch || emailMatch;
    });
  }
  return [...listaFiltrada].sort((a, b) => a.id_usuario - b.id_usuario);
});

const totalPages = computed(() => {
  return Math.ceil(filteredAndSortedList.value.length / itemsPerPage.value) || 1;
});

const filteredList = computed(() => {
  const listaCompleta = filteredAndSortedList.value;
  const start = (currentPage.value - 1) * itemsPerPage.value;
  const end = start + itemsPerPage.value;
  return listaCompleta.slice(start, end);
});

const changePage = (page) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
};

watch(searchText, () => {
  currentPage.value = 1;
});

const toggleRow = (id) => {
  if (expandedRows.value.includes(id)) {
    expandedRows.value = expandedRows.value.filter(rowId => rowId !== id);
  } else {
    expandedRows.value.push(id);
  }
};

const isExpanded = (id) => expandedRows.value.includes(id);

const formatarFecha = (fechaISO) => {
  if (!fechaISO) return 'N/A';
  const fecha = new Date(fechaISO);
  const opciones = { day: '2-digit', month: '2-digit', year: 'numeric' };
  return fecha.toLocaleDateString('es-MX', opciones);
};
</script>

<style scoped>
.filtrosEmpleados {
  justify-content: space-between;
  display: flex;
  padding: 20px 20px 20px 50px;
  align-items: center;
}

.tituloModulo {
  font-size: 25px;
  color: #2a428c;
  font-weight: bolder;
  font-style: italic;
}

.inputBuscador {
  width: 300px;
  height: 42px;
  max-width: 250px;
  z-index: 10;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 0 15px;
  font-size: 14px;
  transition: border-color 0.3s, box-shadow 0.3s;
  margin-right: 20px;
}

.inputBuscador:focus {
  outline: none;
  border-color: #29b9f6;
  box-shadow: 0 0 0 3px rgba(47, 141, 183, 0.2);
}

.default {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}

.cabecera {
  background: black;
  color: white;
  height: 50px;
}

.default td,
.default th {
  border: none;
  padding: 8px 12px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tbody tr {
  height: 56px;
  border-bottom: 1px solid #f1f5f9;
}

.tbody tr:last-child {
  border-bottom: none;
}

.default tr:nth-child(even) {
  background-color: #f8fafc;
}

.default th {
  background-color: black;
  color: #fff;
  font-size: 16px;
  letter-spacing: 1px;
}

.tbody {
  font-size: 14.5px;
}

.mensajeNoResultados {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #691c32;
  padding: 20px 0;
}

.paginacion-fija {
  margin-top: 0;
  padding: 15px 0;
}

.tabla-con-loader {
  position: relative;
}

.fila-loader {
  height: 50vh;
}

.tabla-scrollable {
  background: white;
  box-shadow: 0px 3px 6px #00000029;
}

thead th {
  position: sticky;
  top: 0;
  background-color: #000;
  color: white;
  z-index: 10;
}

.mobile-only {
  display: none;
}

.mobile-detail-row {
  display: none;
}

@media (max-width: 810px) {
  .desktop-only {
    display: none;
  }

  .mobile-only {
    display: table-cell;
    vertical-align: middle;
  }

  .default {
    table-layout: auto;
  }

  .tbody tr {
    height: auto;
  }

  .tituloModulo {
    font-size: 25px;
    margin-bottom: 15px;
  }

  .filtrosEmpleados {
    padding: 20px;
    flex-direction: column;
  }

  .nombre-celda {
    font-weight: 600;
    color: #333;
    white-space: normal;
  }

  .btn-toggle {
    background: transparent;
    border: none;
    font-size: 18px;
    color: #29b9f6;
    padding: 8px;
  }

  .fila-activa {
    background-color: #fff8f5 !important;
    border-bottom: 2px solid #29b9f6;
  }

  .mobile-detail-row {
    display: table-row;
    animation: fadeIn 0.3s ease-out;
  }

  .detalle-wrapper {
    padding: 20px 15px;
  }

  .info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 15px;
    text-align: left;
  }

  .info-item.full-width {
    grid-column: span 2;
  }

  .label {
    font-size: 11px;
    color: #888;
    text-transform: uppercase;
    font-weight: bold;
  }

  .value {
    font-size: 14px;
    color: #222;
    white-space: normal;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>